export default "__VITE_ASSET__3e300015__"